/* eslint-disable no-undef */
import Qty from 'js-quantities';
const DEFAULT_INPUT_ROUNDING = 9;
const DEFAULT_INPUT_ROUNDING_GET = 4;
const DYNAMIC_DECIMALS = -1;

export function set(value, siUnit, max = null, decimals = DEFAULT_INPUT_ROUNDING) {
    value += '';
    value = value.replace(',', '.');
    value = value.replace('²', '^2');

    if (value === '' || value === undefined) {
        return undefined;
    }

    if (!isNaN(value)) {
        value += siUnit;
    }

    let qty = Qty.parse(value);
    if (qty !== null && qty.isCompatible(new Qty('1 ' + siUnit))) {
        qty.scalar = parseFloat(Number(qty.scalar).toFixed(decimals));
        if (max !== null && qty.scalar > max) {
            qty.scalar = max;
        }

        return qty;
    } else {
        return undefined;
    }
}

export function get(qty, decimals = DEFAULT_INPUT_ROUNDING_GET) {
    if (qty === undefined || qty === null) {
        return '';
    }

    let newQty = new Qty(qty.toString());
    if (decimals !== DYNAMIC_DECIMALS)
        newQty.scalar = newQty.scalar.toFixed(decimals);

    return newQty.toString();
}

export function convert(qty, toUnit) {
    if (qty === undefined || qty === null) {
        // console.warn('Trying to convert undefined/null qty', qty, toUnit);
        return undefined;
    }

    if (qty.isCompatible(new Qty('1 ' + toUnit))) {
        return qty.to(toUnit).toString();
    } else {
        // console.error('Quantity is not compatible with ' + toUnit, qty);
        return undefined;
    }
}

export function getSpeedUnit(distance, time) {
    //
    return distance + '/' + time;
}

export function getAccelerationUnit(distance, time) {
    return getSpeedUnit(distance, time) + '²';
}

export function getJerkUnit(distance, time) {
    return getSpeedUnit(distance, time) + '³';
}

import Scenario from '../models/Scenario';
import ApplicationData from '../models/ApplicationData';
import MovementProfile from '../models/MovementProfile';

export function setUnitProfiles(units) {
    let profiles = localStorage.getItem('unit_profiles');

    if (profiles !== undefined && profiles !== null) {
        profiles = JSON.parse(profiles);

        Scenario.unitProfiles = profiles;
        ApplicationData.unitProfiles = profiles;
        MovementProfile.unitProfiles = profiles;

        let profile = profiles.find(item => {
            return item.name.toLowerCase() === units.toLowerCase();
        });

        if (profile !== undefined) {
            Scenario.unitProfile = profile;
            ApplicationData.unitProfile = profile;
            MovementProfile.unitProfile = profile;
        }
    }
}

export function increase(qty, factor = 0.1, max = null) {
    let val = Number(qty.scalar);
    let units = qty.units();

    if (val.toFixed(DEFAULT_INPUT_ROUNDING) == '0.00' || isNaN(val)) {
        return Qty.parse(
            Number(0.01).toFixed(
                units !== null && units.toLowerCase() === 'hp' ? 4 : DEFAULT_INPUT_ROUNDING,
            ) +
                ' ' +
                units,
        );
    }

    let newFactor;
    if (val > 0) {
        newFactor = 1 + factor;
    } else {
        newFactor = 1 - factor;
    }

    let oldVal = val;
    if (val < 0 && val >= -0.001) {
        val *= -1;
    } else {
        val *= Number(newFactor);
    }

    if (
        Number(oldVal).toFixed(DEFAULT_INPUT_ROUNDING) ===
        Number(val).toFixed(DEFAULT_INPUT_ROUNDING)
    ) {
        val = oldVal + 0.001;
    }

    if (max !== null && max !== undefined) {
        if (val > max) {
            val = max;
        }
    }

    let newVal = Number(val);
    return Qty.parse(newVal + ' ' + units);
}

export function decrease(qty, factor = 0.1) {
    // Get scalar and unit of the qty
    let val = Number(qty.scalar);
    let oldVal = val;
    let units = qty.units();

    // If there is no value yet, return 0.1
    if (val.toFixed(DEFAULT_INPUT_ROUNDING) == '0.00' || isNaN(val)) {
        return Qty.parse(
            Number(0).toFixed(
                units !== null && units.toLowerCase() === 'hp' ? 4 : DEFAULT_INPUT_ROUNDING,
            ) +
                ' ' +
                units,
        );
    }

    // Set the division factor
    let newFactor;
    if (val > 0) {
        newFactor = 1 + factor;
    } else {
        newFactor = 1 - factor;
    }

    val /= Number(newFactor);

    if (
        Number(oldVal).toFixed(DEFAULT_INPUT_ROUNDING) ===
        Number(val).toFixed(DEFAULT_INPUT_ROUNDING)
    ) {
        val = oldVal - 0.001;
    }

    if (oldVal >= 0 && val < 0) {
        val = 0;
    }

    // Create a new qty object.
    let newVal = Number(val);
    return Qty.parse(newVal + ' ' + units);
}

export function max(num, max) {
    if (num > max) {
        return max;
    }

    return num;
}

export function min(num, min) {
    if (num < min) {
        return min;
    }

    return num;
}

export function getUnitProfile(units) {
    let profiles = localStorage.getItem('unit_profiles');

    if (profiles !== undefined && profiles !== null) {
        profiles = JSON.parse(profiles);

        let profile = profiles.find(item => {
            return item.name.toLowerCase() === units.toLowerCase();
        });

        return profile;
    }

    return {};
}

export function getUnit(profile, key, fallback) {
    if (profile !== undefined && profile[key] !== undefined) {
        if (profile[key] === 'revolution') {
            return 'rotation';
        }

        return profile[key];
    }

    return fallback;
}
